// extracted by mini-css-extract-plugin
export default {"control":"styles_control__raYaK","controlPrev":"styles_controlPrev__q4ubn","controlNext":"styles_controlNext__+1ou4"};